import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Paper, Avatar, ToggleButton, ToggleButtonGroup, CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import useApiManager from '../../utils/Api/apiManager';
import { useNavigate } from "react-router-dom";
import Drawer from '../../components/Accounts/Details/Drawer';
import BasicDetails from '../../components/Accounts/Details/BasicDetails/BasicDetails';
import FullDetails from '../../components/Accounts/Details/FullDetails/FullDetails';
import Deals from '../../components/Accounts/Details/Deals/Deals';
import Contacts from '../../components/Accounts/Details/Contacts/Contacts';
import ApartmentTwoToneIcon from '@mui/icons-material/ApartmentTwoTone';
import Notes from '../../components/Common/Notes/Notes';
import Attachments from '../../components/Common/Attachments/Attachments'

const AccountDetails = () => {
    const { accountId } = useParams(); // Get accountID from URL
    const [accountDetails, setAccountDetails] = useState(null);
    const [notes, setNotes] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [accountContacts, setAccountContacts] = useState(null);
    const [accountDeals, setAccountDeals] = useState(null);
    const detailsRef = useRef(null);
    const notesRef = useRef(null);
    const attachmentsRef = useRef(null);
    const contactsRef = useRef(null);
    const dealsRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const { get } = useApiManager();

    const scrollToSection = (ref) => {
        ref.current.scrollIntoView({ behavior: 'smooth' });
    };

    const fetchAccountDetails = async () => {
        setLoading(true);

        try {
            const data = await get(`/accounts/${accountId}`);
            setAccountDetails(data);
            const accountName = data.accountName ?? '';
            document.title = `${accountName} (Account) - iLead CRM`.trim() || 'Account Details';
        } catch (error) {
            console.error('Error fetching account details:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchNotes = async () => {
        setLoading(true);

        try {
            const notes = await get(`/accounts/${accountId}/notes`);
            setNotes(notes);
        } catch (error) {
            console.error('Error fetching account notes:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAttachments = async () => {
        setLoading(true);

        try {
            const attachments = await get(`/accounts/${accountId}/attachments`);
            setAttachments(attachments);
        } catch (error) {
            console.error('Error fetching account attachments:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAccountContacts = async () => {
        setLoading(true);

        try {
            const data = await get(`/accounts/${accountId}/contacts`);
            setAccountContacts(data);
        } catch (error) {
            console.error('Error fetching account contacts details:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAccountDeals = async () => {
        setLoading(true);

        try {
            const data = await get(`/accounts/${accountId}/deals`);
            setAccountDeals(data);
        } catch (error) {
            console.error('Error fetching account deals:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAccountDetails();
        fetchNotes();
        fetchAttachments();
        fetchAccountContacts();
        fetchAccountDeals();
    }, []);

    return (
        <div style={{}}>
            <Paper elevation={0} sx={{
                p: 2
            }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <ApartmentTwoToneIcon />
                        <h3> {loading ? "Loading..." : (accountDetails?.accountName || '')}  </h3>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>

                        <Link to={`/accounts/edit/${accountId}`}>
                            <Button variant="outlined">Edit</Button>
                        </Link>
                    </Box>
                </Box>
            </Paper >
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Box id='drawer' sx={{ display: 'flex' }}>
                    <Drawer
                        scrollToSection={scrollToSection}
                        sections={{
                            detailsRef,
                            notesRef,
                            attachmentsRef,
                            dealsRef,
                            contactsRef
                        }} />
                </Box>
                <Box id='main' sx={{ flexGrow: 1, paddingTop: 3, paddingRight: 5 }}>
                    {/* <ToggleButtonGroup
                        color="primary"
                        exclusive
                        aria-label="Platform"
                        sx={{ marginBottom: 3 }}
                    >
                        <ToggleButton value="overview">Overview</ToggleButton>
                        <ToggleButton value="history">History</ToggleButton>
                    </ToggleButtonGroup> */}
                    <Box sx={{ '& > * > *': { marginBottom: 3 } }}>

                        <div id='overview'>
                            <div>
                                {/* <BasicDetails data={leadDetails} /> */}
                                <BasicDetails data={accountDetails} />
                            </div>
                            <div ref={detailsRef}>
                                <FullDetails data={accountDetails} />
                            </div>
                            <div ref={notesRef}>
                                <Notes data={notes} fetchNotes={fetchNotes} entity={'accounts'} />
                            </div>
                            <div ref={attachmentsRef}>
                                <Attachments data={attachments} fetchAttachments={fetchAttachments} entity={'accounts'}/>
                            </div>
                            <div ref={dealsRef}>
                                <Deals data={accountDeals} fetchDeals={fetchAccountDeals} accountId={accountId} />
                            </div>
                            <div ref={contactsRef}>
                                <Contacts data={accountContacts} fetchContacts={fetchAccountContacts} accountId={accountId} />
                            </div>

                        </div>
                        <div id='history'></div>
                    </Box>
                </Box>
            </Box>

        </div>
    )
};

export default AccountDetails;